import { Table as AntdTable } from "antd";
import { language } from "../../locales";

const lang = language?.config.component.table;

export const Table = (props: any) => {
  const { page, onPageChange, ...otherProps } = props;

  return (
    <AntdTable
      pagination={page ? {
        current: page.Page,
        pageSize: page.PageSize,
        total: page.Total,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: [10, 20, 50, 100],
        showTotal: total => `${lang?.total} ${total} ${lang?.items}`,
        onChange: onPageChange
      } : false}
      {...otherProps}
    />
  );
}

interface pageProps {
  Page: number;
  PageSize: number;
  Total: number;
}

export const DEFAULT_PAGE_DATA: pageProps = {
  Page: 1,
  PageSize: 10,
  Total: 0
};